import React, { useState, forwardRef } from 'react'
import styled from 'styled-components'

import { Flex } from '../Box'
import { Input, InputProps } from '../Input'

import { ToggleShowPasswordButton } from './ToggleShowPasswordButton'
import {
  ToggleCopyPasswordButton,
  ToggleGeneratePasswordButton,
} from './ToggleCopyPasswordButton'

export function generatePassword(length = 6) {
  const lower = 'abcdefghijklmnopqrstuvwxyz'
  const upperChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const numChars = '0123456789'
  const specialChars = '!@#$%^&*()-_=+[]{}|;:,.<>?'
  let chars = lower

  chars += upperChars
  chars += numChars
  chars += specialChars

  let pass = ''
  for (let i = 0; i < length; i++) {
    const randIdx = Math.floor(Math.random() * chars.length)
    pass += chars[randIdx]
  }

  return pass
}

const StyledPasswordInput = styled(Input)`
  /*
    This overrides the right padding in order to have no text
    under the button to toggle the visibility.
  */
  padding-right: 48px !important; /* stylelint-disable-line declaration-no-important */
`

interface PasswordInputProps extends InputProps {
  onPwdCopy?: () => void
  onGeneratePassword?: () => void
}

/* eslint-disable-next-line react/display-name */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ ...props }: PasswordInputProps, ref) => {
    const [showPassword, setShowPassword] = useState(false)

    return (
      <Flex position="relative">
        <StyledPasswordInput
          type={showPassword ? 'text' : 'password'}
          id="password"
          name="password"
          ref={ref}
          {...props}
        />
        {props.onGeneratePassword ? (
          <ToggleGeneratePasswordButton onClick={props.onGeneratePassword} />
        ) : null}
        {props.onPwdCopy ? (
          <ToggleCopyPasswordButton
            disabled={!props.value}
            onClick={props.onPwdCopy}
          />
        ) : null}
        <ToggleShowPasswordButton
          showPassword={showPassword}
          onClick={() => setShowPassword(value => !value)}
          disabled={props.disabled}
        />
      </Flex>
    )
  }
)
